import * as React from 'react';
import { IActions, actionCreator } from './store/action/creators';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { Grid, StyledComponentProps } from '@material-ui/core';
import { IApplicationState } from '../../store/ApplicationState';
import { connect } from 'react-redux';
import Paper from '../../ui-components/Containers/Paper';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { IState } from './store/state';
import { accessrule, room } from '../../model/room';
import RoomList from './components/RoomList';
import RoomAccessRule from './components/RoomAccessRule';
import SaveIconButton from '../../ui-components/Button/SaveIconButton';
import Filters from './components/components/Filters';
// import { Detail } from './components/Detail/detail';
// import { Followers } from './components/Detail/followers';
// import { Export } from './components/Export';

interface IProps extends IActions, IState, StyledComponentProps, IMediaQueryProps {
    navigateTo: (path: string) => void;
    match: {
        params: {
            id: string
        }
    }
}

interface IInternalState {
    isCollapsed: boolean;
    filter: string;
}

class RoomsContainer extends React.Component<IProps, IInternalState>
{
    state = { isCollapsed: false, filter: "" };

    componentDidMount() {

        this.props.loadRooms().then(r => {
            let id = r.length > 0 ? r[0]._id : "";
            if (id)
                this.handleRoomSelection(id)
        });
    }

    handleRoomSelection = (id: string) => {
        this.props.selectRoom(id);
        this.props.loadRoomDetail(id);
    }
    handleBlur = (text: string, id: string) => {
        // console.log("BLUR:" + id);
        this.props.updateRoomDescription(text, id);
    }
    handleChange = (text: string, id: string) => {
        this.props.changeRoomDescription(text, id);
    }
    saveRoom = () => {
        this.props.saveRoom(this.props.room);
    }
    changeAccessRule = (accessrule: accessrule) => {
        this.props.changeAccessRule(accessrule);
    }
    changeRoomInEdit = (room: room) => {
        this.props.changeRoomInEdit(room);
    }

    render() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        filter={this.state.filter}
                        updateFilter={(filter) => { this.setState({ filter: filter }) }}
                        createRoom={this.props.createRoom}
                        classes={this.props.classes}
                        smallScreen={this.props.smallScreen} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Paper title='Elenco Accessi'
                        fullHeight={!this.props.smallScreen}
                        contentContainerStyle={this.props.smallScreen ? { height: '300px', overflow: 'auto' } : {}}
                    >
                        <RoomList
                            filter={this.state.filter}
                            rooms={this.props.rooms}
                            selected={this.props.room ? this.props.room._id : undefined}
                            selectRoom={this.handleRoomSelection}
                            handleBlur={this.handleBlur}
                            handleChange={this.handleChange}
                            classes={this.props.classes}
                        // edit={this.editRoom}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Paper title='Regole Accesso' fullHeight={true}>
                        {this.props.room ? <>
                        <RoomAccessRule
                            selected={this.props.room ? this.props.room._id : undefined}
                            changeAccessRule={this.changeAccessRule}
                            changeRoomInEdit={this.changeRoomInEdit}
                            room={this.props.room ? this.props.room : undefined}
                            accessrule={this.props.room ? this.props.room.accessRule : undefined}
                            classes={this.props.classes} />
                            <div className={this.props.classes.searchButton}>
                                <SaveIconButton onClick={this.saveRoom} />
                                <br/>
                            </div>
                        </> : <div></div>}
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState) => ({
    ...state.rooms
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch),
        navigateTo: authActions(dispatch).navigateTo
    }
};

export const Rooms = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(WithMediaQuery(RoomsContainer)));